<template>
    <div class="section grey-card">
        <v-container class="px-10">
            <v-row cols="12">
                <v-col cols="12" md="4">
                    <v-card class="pa-7 fill-height">
                        <v-card-text><v-icon color="primary" class="d-flex align-center" size="70px">mdi-share-all</v-icon></v-card-text>
                        <v-card-title class="text-h4">Chat Routing</v-card-title>
                        <v-card-text>Automatically direct incoming messages to the right agent queue. <br><br>Keep response times low by ensuring billing queries, support issues, and renewals all reach the right team straight away.<br><br>
                        <div class="d-flex flex-wrap justify-space-around align-center">
                            <div class="pa-2"><v-chip style="white-space: normal;">Incoming Message</v-chip></div>
                            <div class="pa-2">
                                <v-icon>mdi-arrow-right</v-icon>
                            </div>
                            <div class="pa-2">
                                <v-chip class="mb-2 py-md-5 py-lg-0" color="primary" style="white-space: normal;">Collections</v-chip><br>
                                <v-chip class="mb-2 py-md-5 py-lg-0" color="primary" style="white-space: normal;">Membership Support</v-chip><br>
                                <v-chip color="primary py-md-5 py-lg-0" style="white-space: normal;">Billing Queue</v-chip>
                            </div>
                        </div>

                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4">
                    <v-card class="pa-7 fill-height" style="position: relative;">
                        <v-card-text><v-icon color="primary" class="d-flex align-center" size="70px">mdi-tag-text</v-icon></v-card-text>
                        <v-card-title class="text-h4">Chat Tags</v-card-title>
                        <v-card-text>Label conversations with tags like High Priority, Collections, or Renewal. <br><br>Tags make it easy to filter and track chats so your team always knows what to focus on.</v-card-text>
                        <br><br>
                        <div class="text-right" style="position: absolute; bottom: 2em; right: 2em;">
                            <v-chip v-for="tag in tags" :key="tag" class="ml-2 mb-2"
                                color="primary"
                                label
                                >
                                <v-icon class="mr-2">mdi-tag</v-icon>
                                {{ tag }}
                            </v-chip>
                        </div>

                    </v-card>

                </v-col>
                <v-col cols="12" md="4">
                    <v-card class="pa-7 fill-height">
                        <v-card-text><v-icon color="primary" class="d-flex align-center" size="70px">mdi-message-flash</v-icon></v-card-text>
                        <v-card-title class="text-h4">Quick Replies</v-card-title>
                        <v-card-text>Create and send saved responses with a single click.
                            <br><br>Customise replies and set up keywords so the right message appears when you need it most.<br><br>
                        <div>
                            <v-row cols="12" justify="center">
                                <v-col cols="12" lg="5">
                                    <v-chip class="text-center pa-4" style="white-space: normal; height: 100%;">
                                        Hey {name}, thanks for reaching out!
                                    </v-chip>
                                </v-col>
                                <v-col cols="12" lg="5">
                                    <v-chip class="text-center pa-4" style="white-space: normal; height: 100%;">
                                        We’re open 9–5, Mon–Fri.
                                    </v-chip>
                                </v-col>
                            </v-row>
                            <v-row cols="12" justify="center">
                                <v-col cols="12" lg="5">
                                    <v-chip class="text-center pa-4" style="white-space: normal; height: 100%;">
                                        Your order is on the way to {address}.
                                    </v-chip>
                                </v-col>
                                <v-col cols="12" lg="5">
                                    <v-chip class="text-center pa-4" style="white-space: normal; height: 100%;">
                                        Let me step you through that. (1) ...
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </div>

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'ChatRouting',
    data: () => ({

        tags: [
            'Interested',
            'Lead',
            'VIP'
        ]
    })
}
</script>

<style lang="scss">



</style>